//
//  ExistingUserMigration.tsx
//
//  isana.net,inc. Proprietary and Confidential
//
//  既存(移行)ユーザ向け：確認操作なしで自動的に再連携を実行する（E1-5）。
//  画面はスピナー表示のみ。成功時は完了画面へ遷移、失敗時はエラーを表示する。
//

import { type ReactElement, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { migrateUserInfo } from "../network/googleHealth/api";

interface Props {
  /** 共通基盤が発行したJWT。サーバ側で検証して移行を実行する */
  token: string;
}

const ExistingUserMigration = ({ token }: Props): ReactElement => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  // 二重実行防止（React StrictMode の effect 二重呼び出し対策）。移行はサーバ側も冪等。
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    migrateUserInfo(token)
      .then(() => navigate("/google-health-account-linkage-complete"))
      .catch((error: Error) => setErrorMessage(error.message));
  }, [token, navigate]);

  if (errorMessage) {
    return (
      <Box sx={{ mt: 2 }}>
        <Alert severity="error">{errorMessage}</Alert>
      </Box>
    );
  }

  return (
    <>
      <Typography sx={{ mb: 2 }}>
        連携しています。しばらくお待ちください。
      </Typography>
      <CircularProgress />
    </>
  );
};

export default ExistingUserMigration;
